<template>
  <div class="pa-2">
    
    <TotalAndAssignedCards
      :dataLoaded="dataLoaded"
      :totalItems="totalItems"
      :totalAssignedToYourTeams="totalAssignedToYourTeams"
      :totalAssignedToYou="totalAssignedToYou"
      :sparklines="sparklines"
      v-model:filterByMyTeams="filterByMyTeams"
      v-model:filterByMe="filterByMe"
      @filterChange="handleFilterChange"
    />

    <!-- Issue Status Breakdown and Responsible Party Row -->
    <v-row dense class="mt-4">
      <v-col cols="12" md="4">
        <v-skeleton-loader
          v-if="!dataLoaded"
          type="card"
          height="300"
        ></v-skeleton-loader>
        <StatusBreakdownCard
          v-else
          :title="$t('issueStatusBreakdown')"
          :exportFilename="$t('issueStatusBreakdown') + '.png'"
          :items="statusBreakdown"
          :loading="statusBreakdownLoading"
        />
      </v-col>
      <v-col cols="12" md="8">
        <v-skeleton-loader
          v-if="!dataLoaded"
          type="card"
          height="300"
        ></v-skeleton-loader>
        <BaseTimeSeriesChart
          v-else
          mode="cumulative"
          bandOrder="asc"
          :title="$t('burnup.title')"
          :infoText="$t('burnup.tooltip')"
          :exportFilename="$t('rdriveBurndownChart') + '.png'"
          :showToolbar="showChartDownload"
          :filterContext="burndownContexts"
          :dataLoaded="dataLoaded"
          v-bind="burndownChart"
        />
      </v-col>
    </v-row>

    <StackedHorizontalBarChart
      :title="$t('issueBreakdown')"
      :exportFilename="$t('issueBreakdown') + '.png'"
      v-bind="categoryChart"
      :filterContext="filterContext"
      :chartFontColor="chartFontColor"
      :dataLoaded="dataLoaded"
      skipEmptyLevels
    />

    <!-- Items Data Table -->
    <v-row>
      <v-col cols="12">
        <v-skeleton-loader
          v-if="!dataLoaded"
          type="table"
          height="400"
        ></v-skeleton-loader>
        <IssuesGrid v-bind="issuesGrid" />
      </v-col>
    </v-row>
  </div>
</template>

<script src="./model.js"></script>
<style src="./style.css" scoped></style>
